// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mdckcgxuuyspxxnxuiuc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1kY2tjZ3h1dXlzcHh4bnh1aXVjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk4Mzk5OTIsImV4cCI6MjA3NTQxNTk5Mn0.5x7DbEEgn7RXRI2jbT0IgqelfN2b7Pi8ltW6XqROXkw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // localStorage padrão: sessão persiste entre recargas/abas.
    // (O brokeredPreviewStorage apagava o token ao recarregar o preview,
    // pois o editor Lovable não conhece o Supabase externo deste projeto.)
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});